module.exports = __webpack_public_path__ + "img/pay-ico.5c27bc0.png";